var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.818 7.707V6.62c0-1.246-.961-2.256-2.148-2.256H4.33c-1.187 0-2.148 1.01-2.148 2.256v1.088c0 .054.02.105.056.143a.187.187 0 0 0 .136.059h19.252c.051 0 .1-.021.136-.06a.207.207 0 0 0 .056-.142zM2.182 9.4v6.89c0 1.246.961 2.256 2.148 2.256h15.34c1.187 0 2.148-1.01 2.148-2.256v-6.89a.207.207 0 0 0-.056-.142.187.187 0 0 0-.136-.059H2.374c-.051 0-.1.021-.136.059a.207.207 0 0 0-.056.142zm4.909 5.278c0 .356-.275.645-.614.645h-.613c-.34 0-.614-.289-.614-.645v-.644c0-.356.275-.645.614-.645h.613c.34 0 .614.289.614.645v.644z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBlack);
export default __webpack_public_path__ + "static/media/cardBlack.2321e117a2a599f296d56ae7d1906e07.svg";
export { ForwardRef as ReactComponent };